document.addEventListener("DOMContentLoaded", function() {

    const scrollShowPoint = 120 * window.innerHeight / 100; // top spacing
    const scrollHideBuffer = 50 * window.innerHeight / 100; // bottom spacing

    $(window).on("scroll", function () {
        const currentScroll = $(this).scrollTop();
        const totalHeight = $(document).height();
        const windowHeight = $(window).height();

        const distanceToBottom = totalHeight - (currentScroll + windowHeight);

        $(".floating-box").each(function () {
            const $item = $(this);

            // show
            if (currentScroll >= scrollShowPoint && distanceToBottom >= scrollHideBuffer) {
                if (!$item.hasClass("visible")) $item.addClass("visible");
            }
            // hide
            else {
                if ($item.hasClass("visible")) $item.removeClass("visible");
            }
        });
    });
    console.log("Sticky:", $(".PDP-col-parent .floating-box").length);


});